export default {
    data() {
        return {
            config: {
                host: process.env.VUE_APP_HOST_DOMAIN,
                apiUrl: process.env.VUE_APP_HOST_DOMAIN + process.env.VUE_APP_BASE_API,
                kareliaHost: process.env.VUE_APP_KARELIAS_HOST,
                env: process.env.VUE_APP_ENV
            }
        }
    }
}